"use strict";

require("@patsnap-biz/icon/lib/style");
require("../../../header/src/style/header_widget.scss");